import { useAppSetting } from "@swa-ui/application";
import { getBootstrapData } from "@swa-ui/bootstrap";
import { getEnvironmentTier } from "@swa-ui/dotcom";

export const useOJTWebappUrl = () => {
  const OJTWebappUrlOverride = useAppSetting("OJTWebappUrlOverride");
  const urlData = getBootstrapData("urls");
  const urlFromData =
    getEnvironmentTier() === "prod"
      ? urlData.OJT_WEBAPP_BASE_PATH_PROD
      : urlData.OJT_WEBAPP_BASE_PATH_NON_PROD;

  return OJTWebappUrlOverride ?? urlFromData;
};
